import { useState } from "react";

// hooks/usePersistedState.ts
const EXPIRY_MS = 2 * 60 * 60 * 1000; // 2h

export const usePersistedState = <T>(key: string, defaultValue: T) => {
  const [state, setState] = useState<T>(() => {
    try {
      const item = localStorage.getItem(key);
      if (!item) return defaultValue;

      const { value, expiresAt } = JSON.parse(item);
      if (Date.now() > expiresAt) {
        localStorage.removeItem(key);
        return defaultValue;
      }

      return value as T;
    } catch {
      return defaultValue;
    }
  });

  const setPersistedState = (value: T) => {
    setState(value);
    localStorage.setItem(
      key,
      JSON.stringify({ value, expiresAt: Date.now() + EXPIRY_MS })
    );
  };

  return [state, setPersistedState] as const;
};
